import { Typography, Button, Row, Col } from 'antd';
import { Sparkles, Mic, FileSearch } from 'lucide-react';

const { Title, Paragraph } = Typography;

export default function AISection() {
    return (
        <div className="section ai-section" id="ai">
            <div className="section-container">
                <Row align="middle" gutter={[48, 48]}>
                    <Col xs={24} md={12}>
                        <div className="ai-content">
                            <div className="ai-badge">
                                <Sparkles size={16} />
                                <span>Powered by Gemini</span>
                            </div>
                            <Title level={2} className="ai-title">
                                Your Intelligent<br />Thinking Partner
                            </Title>
                            <Paragraph className="ai-description">
                                Unlock the power of AI directly within your notes. From summarizing complex articles to voice dictation, Page Notes helps you think faster.
                            </Paragraph>

                            <div className="ai-features-list">
                                <div className="ai-feature-item">
                                    <div className="ai-feature-icon"><FileSearch size={20} /></div>
                                    <div>
                                        <strong>Summarizer</strong>
                                        <p>Turn long articles into concise bullet points in seconds.</p>
                                    </div>
                                </div>
                                <div className="ai-feature-item">
                                    <div className="ai-feature-icon"><Mic size={20} /></div>
                                    <div>
                                        <strong>Talk to Notes</strong>
                                        <p>Dictate your thoughts and let AI transcribe and format them.</p>
                                    </div>
                                </div>
                                <div className="ai-feature-item">
                                    <div className="ai-feature-icon"><Sparkles size={20} /></div>
                                    <div>
                                        <strong>Smart Capture</strong>
                                        <p>Automatically extract key insights from any webpage.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} md={12}>
                        <div className="ai-visual">
                            {/* Placeholder for an AI interaction visual or screenshot */}
                            <div className="ai-card-mockup">
                                <div className="ai-message user">"Summarize this page"</div>
                                <div className="ai-message bot">
                                    <div className="typing-indicator">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <p>Here are the key takeaways from this article...</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
